import { render } from "./Kits.vue?vue&type=template&id=3d4202a6&scoped=true"
import script from "./Kits.vue?vue&type=script&lang=js"
export * from "./Kits.vue?vue&type=script&lang=js"

import "./Kits.vue?vue&type=style&index=0&id=3d4202a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d4202a6"

export default script